// src/components/features/Elevation/components/ElevationStep9Ceiling.jsx
// Ceiling design — swipe-style selection (folder "8.Ceiling" me "Radio"
// naam nahi tha, isliye swipe UI use kiya)

import ElevationSwipeStep from "./shared/ElevationSwipeStep";
import { CEILING_IMAGES } from "../../../../assets/Elevation/elevationAssets";

export default function ElevationStep9Ceiling(props) {
  return (
    <ElevationSwipeStep
      {...props}
      title="Ceiling Design"
      subtitle="Swipe through ceiling styles and pick what you like"
      items={CEILING_IMAGES}
      selectedFieldKey="elevationCeiling"
      likedFieldKey="elevationLikedCeiling"
    />
  );
}
